import { useEffect, useState } from "react";
import "./DownloadApp.css";

// APK servido diretamente pela API (não depende de cópia para pasta estática)
const APK_URL = `${process.env.REACT_APP_API_URL}/midias/mobile/app-release.apk`;
const APK_FILENAME = "app-release.apk";

export default function DownloadApp() {
  const [apkDisponivel, setApkDisponivel] = useState(null);
  const [verificando, setVerificando] = useState(true);
  const [baixando, setBaixando] = useState(false);

  useEffect(() => {
    let ativo = true;

    async function verificarApk() {
      try {
        const resposta = await fetch(APK_URL, { method: "HEAD", cache: "no-store" });
        if (!ativo) return;
        setApkDisponivel(resposta.ok);
      } catch {
        if (!ativo) return;
        setApkDisponivel(false);
      } finally {
        if (ativo) setVerificando(false);
      }
    }

    verificarApk();

    return () => {
      ativo = false;
    };
  }, []);

  // Função para forçar download sem abrir nova aba
  const handleDownload = async (e) => {
    e.preventDefault();
    setBaixando(true);
    
    try {
      const response = await fetch(APK_URL, { mode: 'cors' });
      if (!response.ok) throw new Error('Erro ao baixar arquivo');

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = APK_FILENAME;

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(link);
        setBaixando(false);
      }, 100);

    } catch (error) {
      alert('Erro ao baixar arquivo');
      console.error(error);
      setBaixando(false);
    }
  };

  return (
    <div className="da-shell">
      {/* grid decorativo */}
      <div className="da-grid" aria-hidden="true" />

      {/* orbs de luz */}
      <div className="da-orb da-orb--1" aria-hidden="true" />
      <div className="da-orb da-orb--2" aria-hidden="true" />

      <main className="da-card" role="main">
        {/* badge superior */}
        <div className="da-badge">
          <span className="da-badge__dot" />
          ISOLVUS Mobile
        </div>

        {/* ícone central */}
        <div className="da-icon-wrap" aria-hidden="true">
          <i className="bi bi-phone" />
        </div>

        <h1 className="da-title">ISOLVUS Mobile</h1>
        <p className="da-version">Android</p>

        {/* botão */}
        <button
          className={`da-btn ${!verificando && apkDisponivel ? "da-btn--active" : "da-btn--disabled"}`}
          onClick={apkDisponivel ? handleDownload : null}
          disabled={!apkDisponivel || verificando || baixando}
          style={{ cursor: (apkDisponivel && !verificando && !baixando) ? 'pointer' : 'not-allowed', border: 'none', background: 'transparent' }}
        >
          {verificando ? (
            <><i className="bi bi-hourglass-split da-btn__spin" /><span>Verificando...</span></>
          ) : baixando ? (
            <><i className="bi bi-gear da-btn__spin" /><span>Baixando...</span></>
          ) : apkDisponivel ? (
            <><i className="bi bi-download" /><span>Baixar</span></>
          ) : (
            <><i className="bi bi-cloud-slash" /><span>Indisponivel</span></>
          )}
        </button>

        {/* linha decorativa */}
        <div className="da-divider" aria-hidden="true">
          <span /><span /><span />
        </div>
      </main>
    </div>
  );
}
